import React, { useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Button } from 'react-bootstrap';
import * as UnsubscribeStore from '../store/Unsubscribe';

import styles from './Home.module.css';
import { ApplicationState } from '../store';

// prop casing matches querystring param exactly
type KnownQueryParams = {
  id: string;
  AppName: string;
  TypeName: string;
};

type HomeProps = PropsFromRedux;

export const HomeDisplay = (props: HomeProps) => {
  const { queryString, unsubscribe, resubscribe } = props;

  const [isUnsubscribed, changeIsUnsubscribed] = useState(true);
  const params = new URLSearchParams(queryString);
  const knownParams = Object.fromEntries(params.entries()) as KnownQueryParams;
  const hasEmail = knownParams.id && knownParams.id !== '';

  if (isUnsubscribed && hasEmail) {
    const decodedEmail = window.atob(knownParams.id);
    const unsubData: UnsubscribeStore.UnsubscribeState = {
      email: decodedEmail,
      appName: knownParams.AppName,
      emailTypeName: knownParams.TypeName,
    };

    unsubscribe(unsubData);
  }

  const handleResubscribe = () => {
    changeIsUnsubscribed(!isUnsubscribed);
    resubscribe();
  };

  const unsubscribedMessage = `You have been successfully unsubscribed to our 
email list, and will no longer receive emails from Select Medical's communications.`;

  const resubscribedMessage = `You have been successfully resubscribed to our 
email list and will once again receive emails from Select Medical's communications.`;

  const resubscribeInstruction =
    "If you've unsubscribed by accident, you are welcome to resubscribe using the button below.";

  return (
    <>
      {hasEmail ? (
        <>
          <h1 className={styles.header}>
            {`You are ${isUnsubscribed ? 'Unsubscribed' : 'Resubscribed'}`}
          </h1>
          <br />
          <p>{isUnsubscribed ? unsubscribedMessage : resubscribedMessage}</p>
          {isUnsubscribed && (
            <>
              <p>{resubscribeInstruction}</p>
              <br />
              <div className={styles.centeredDiv}>
                <Button
                  onClick={() => {
                    handleResubscribe();
                  }}
                >
                  Resubscribe
                </Button>
              </div>
            </>
          )}
        </>
      ) : (
        <>
          <h1 className={styles.header}>Well, this is awkward...</h1>
          <p>
            No email was given to unsubscribe from any of our mailing lists.
          </p>
        </>
      )}
    </>
  );
};

const mapProps = (state: ApplicationState) => ({
  queryString: state.router.location.search,
});

const mapDispatch = {
  unsubscribe: UnsubscribeStore.actionCreators.unsubscribe,
  resubscribe: UnsubscribeStore.actionCreators.resubscribe,
};

const connector = connect(mapProps, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(HomeDisplay);
